import { render, staticRenderFns } from "./SettingsBanno.vue?vue&type=template&id=4868dbf9"
import script from "./SettingsBanno.vue?vue&type=script&lang=js"
export * from "./SettingsBanno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4868dbf9')) {
      api.createRecord('4868dbf9', component.options)
    } else {
      api.reload('4868dbf9', component.options)
    }
    module.hot.accept("./SettingsBanno.vue?vue&type=template&id=4868dbf9", function () {
      api.rerender('4868dbf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsBanno.vue"
export default component.exports